import { env, Environment } from '../utils/environment';

import devConfig from './development.json';
import prodConfig from './production.json';
import stagingConfig from './staging.json';

const configMap = {
  [Environment.DEVELOPMENT]: devConfig,
  [Environment.STAGING]: stagingConfig,
  [Environment.PRODUCTION]: prodConfig,
};

export default configMap[env];
